import React from "react";
import {
  // Center,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  // MenuItemOption,
  // MenuGroup,
  // MenuOptionGroup,
  // MenuDivider,
  Button,
} from "@chakra-ui/react";
import { BiChevronDown } from "react-icons/bi";
// import { IconType } from "react-icons";

interface IActionsButton {
  label: string;
  onClick: (id: string) => void;
}
interface Props {
  actions: IActionsButton[];
  id: string;
}

const ActionsButton = ({ actions, id }: Props) => {
  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<BiChevronDown />}>
        Actions
      </MenuButton>
      <MenuList>
        {actions.map(({ onClick, label }, index) => (
          <MenuItem key={`act-${index}`} onClick={() => onClick(id)}>
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default ActionsButton;
